import { useEffect } from 'react';
import { useWaitlistStore } from '../lib/store';

export function useWaitlistCount() {
  const { 
    count, 
    loading, 
    error, 
    isAnimating,
    fetchCount,
    subscribeToChanges,
    unsubscribeFromChanges
  } = useWaitlistStore();

  useEffect(() => {
    // Initial fetch
    fetchCount();

    // Set up subscription
    subscribeToChanges();

    // Cleanup subscription on unmount
    return () => {
      unsubscribeFromChanges();
    };
  }, [fetchCount, subscribeToChanges, unsubscribeFromChanges]);

  const getTierInfo = (count: number) => {
    if (count < 500) return { name: 'Grundare', spots: 500 - count };
    if (count < 1000) return { name: 'Pionjär', spots: 1000 - count };
    if (count < 1500) return { name: 'Tidig användare', spots: 1500 - count };
    return { name: 'Väntelista', spots: 0 };
  };

  return { 
    count, 
    loading, 
    error,
    isAnimating,
    ...getTierInfo(count)
  };
}